module.exports = __webpack_public_path__ + "static/media/icon_system_rituals_social_instagram.e5a0983e.svg";